
















































































































































































































import mixins from 'vue-typed-mixins';
import { LikertOptions } from '.';
import SurveyUtils from '@/utils/SurveyUtils';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => LikertOptions,
    },
  },

  mounted() {
    // set  values to defaults
    this.$emit('input', {
      ...this.value,
      showUnknown:
        this.value?.showUnknown !== undefined ? this.value?.showUnknown : false,
      showNotes:
        this.value?.showNotes !== undefined ? this.value?.showNotes : false,
      showPrimary:
        this.value?.showPrimary !== undefined ? this.value?.showPrimary : true,
      noterows: this.value?.noterows || 2,
      language: {
        primary: {
          true:
            this.value?.language?.primary?.true ||
            this.$languageobj(
              'model.question.options.likert.language.primary.true.default'
            ),
          false:
            this.value?.language?.primary?.false ||
            this.$languageobj(
              'model.question.options.likert.language.primary.false.default'
            ),
          unknown:
            this.value?.language?.primary?.unknown ||
            this.$languageobj(
              'model.question.options.likert.language.primary.unknown.default'
            ),
        },
        secondary: {
          question:
            this.value?.language?.secondary?.question || this.$languageobj(),
        },
        notes:
          this.value?.language?.notes ||
          this.$languageobj(
            'model.question.options.likert.language.notes.default'
          ),
      },
      secondary: {
        options:
          this.value?.secondary?.options?.map((option) => ({
            ...option,
            text: option.text || this.$languageobj(),
            acronym: option.acronym || this.$languageobj(),
          })) || [],
      },
    });
  },

  methods: {
    createOption() {
      this.value.secondary.options.push({
        text: this.$languageobj(),
        acronym: this.$languageobj(),
        key: '',
        score: undefined,
      });
    },
  },
});
